import { useState, useCallback } from 'react';

interface UseTicketReplyProps {
  onSuccess?: () => void;
}

export function useTicketReply({ onSuccess }: UseTicketReplyProps) {
  const [replyDialogOpen, setReplyDialogOpen] = useState(false);
  
  const openReplyDialog = useCallback(() => {
    setReplyDialogOpen(true);
  }, []);
  
  const closeReplyDialog = useCallback(() => {
    setReplyDialogOpen(false);
    if (onSuccess) {
      onSuccess();
    }
  }, [onSuccess]);
  
  return {
    replyDialogOpen,
    openReplyDialog,
    closeReplyDialog,
  };
}